import { i18n } from "./index";

type Lang = string;
type Namespace = string;

const loadedMap = new Map<string, boolean>();

// 使用 import.meta.glob 自动导入所有语言文件
const localeModules = import.meta.glob("./*/*.ts");

export async function loadLocaleNamespace(lang: Lang, namespace: Namespace) {
  const key = `${lang}:${namespace}`;
  if (loadedMap.get(key)) return true;

  try {
    // 构造文件路径
    const modulePath = `./${lang}/${namespace}.ts`;

    // 检查模块是否存在
    const moduleLoader = localeModules[modulePath];
    if (!moduleLoader) {
      throw new Error(`Language module not found: ${modulePath}`);
    }

    // 导入模块
    const messages = await moduleLoader();

    i18n.global.mergeLocaleMessage(lang, {
      [namespace]: (messages as any).default,
    });
    loadedMap.set(key, true);
    return true;
  } catch (error) {
    console.warn(`Failed to load locale file: ${lang}/${namespace}`, error);
    return false;
  }
}

// 加载多个语言包
export async function loadMultipleNamespaces(lang: string, namespaces: string[]) {
  const promises = namespaces.map(namespace => loadLocaleNamespace(lang, namespace));
  await Promise.allSettled(promises);
}
